<template>
	<a-pagination :current="current" :pageSize="pageSize" :total="total"
			showSizeChanger
			size="small"
			:pageSizeOptions="['10','20','30','50','100','1000']"
			:show-total="t => `共 ${t} 条数据`"
			@change="pageChange"
			@showSizeChange="pageSizeChange"
        >
           <template slot="buildOptionText" slot-scope="props">
            <span>{{ props.value }}条/页</span>
           </template>
       </a-pagination>
</template>

<script>
export default {
	props:["current","pageSize","total","pageChange","pageSizeChange"]
}
</script>
<style scoped>
.ant-pagination{
    margin: 20px 20px 0px 0px;
    display: flex;
    justify-content: flex-end;
}
</style>

